import { ArrowUpRight } from "../../../components/svgs";
const CourseJoinSection = ({ selectedLocation, selectedCourseData }) => {
  const isAfrica = selectedLocation?.name === "Africa" || !selectedLocation;
  const whatsappUrl = isAfrica
    ? "https://wa.me/2348035152982"
    : selectedCourseData?.chatWithUsUrl || "https://wa.me/12028217864";

  return (
    <section className="bg-[#FFFBF2]">
      <div className="max-w-[1260px] mx-auto px-4 py-14 md:py-16 flex flex-col md:flex-row items-center justify-between gap-8">
        <div>
          <p className="text-primary tracking-[0.19em] uppercase text-[14px] font-extrabold flex items-center gap-2 mb-4">
            <span className="inline-block w-6 h-[3px] bg-secondary rounded-full" />
            Join The Community
          </p>
          <h2 className="text-primary font-bold text-3xl md:text-5xl tracking-tight max-w-xl mb-2">
            More than a course. A community.
          </h2>
          <p className="text-[#565656] text-sm md:text-base m-0">
            Connect with over 30,000 learners, mentors, and industry experts
            dedicated to helping you succeed.
          </p>
        </div>

        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="custom-btn custom-btn-with-shadow-primary inline-flex items-center gap-3 bg-primary text-white font-bold text-sm rounded-xl px-8 py-4 whitespace-nowrap focus:outline-none"
        >
          Chat with us{" "}
          <span aria-hidden="true">
            <ArrowUpRight className="w-3.5 h-3.5 inline-block" />
          </span>
        </a>
      </div>
    </section>
  );
};

export default CourseJoinSection;
